<template>
    <div class="gray-line">
        
    </div>
</template>

<script>
export default {
    name: 'GrayLine',
};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/global.scss';
    .gray-line {
        height: rem(12);
        background-color: #D9D9D9;
        opacity: 0.2;
    }
</style>